import React, { useEffect, useId, useRef } from 'react';
import { getUnlockedVocabularyStage } from './utils/vocabularyProgress';
import './VocabularyResumeDialog.css';

export default function VocabularyResumeDialog({ topicName, progress, onSelectStage, onBack }) {
  const allCompleted = progress.completedThrough === 4;
  const panelRef = useRef(null);
  const titleId = useId();
  const unlocked = getUnlockedVocabularyStage(progress);

  useEffect(() => {
    panelRef.current?.querySelector('button:not(:disabled)')?.focus();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      onBack();
      return;
    }
    if (event.key !== 'Tab') return;
    const buttons = [...panelRef.current.querySelectorAll('button:not(:disabled)')];
    const first = buttons[0];
    const last = buttons[buttons.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  return (
    <div className="vocabulary-resume-overlay" dir="rtl">
      <section className="vocabulary-resume-panel" role="dialog" aria-modal="true" aria-labelledby={titleId} ref={panelRef} onKeyDown={handleKeyDown}>
        <h2 id={titleId}>{topicName}</h2>
        <p className="vocabulary-resume-status">{allCompleted ? 'כל ארבעת השלבים הושלמו' : `הגעת לשלב ${unlocked} מתוך 4`}</p>
        <h3>בחר שלב:</h3>
        <div className="vocabulary-resume-stages">
          {[1, 2, 3, 4].map(stage => {
            const completed = stage <= progress.completedThrough;
            const locked = stage > unlocked;
            const available = !completed && !locked;
            return (
              <button type="button" key={stage} className={`vocabulary-resume-stage${available ? ' vocabulary-resume-primary' : ''}`} disabled={locked} onClick={() => onSelectStage(stage)}>
                <span>{available ? `המשך לשלב ${stage}` : `שלב ${stage}`}</span>
                {!available && <span className="vocabulary-resume-stage-status">{locked ? 'נעול \uD83D\uDD12' : 'הושלם \u2713'}</span>}
              </button>
            );
          })}
        </div>
        <button type="button" className="vocabulary-resume-back" onClick={onBack}>חזרה למשחקי אוצר מילים</button>
      </section>
    </div>
  );
}
